import { backgroundCheckEntityName } from '@/backend/features/background-check/shared';
import { RmsAccountDetails } from '@/ui/features/accounts/RmsAccountDetails';
import { useAccountAuditFormatter } from '@/ui/features/accounts/hooks/useAccountAuditFormatter';
import { useAccountSlideoutAdditionalMenuItems } from '@/ui/features/accounts/hooks/useAccountSlideoutAdditionalMenuItems';
import { useSelectedPersonBackgroundCheckData } from '@/ui/hooks/useSelectedPersonBackgroundCheckData';
import { filterAccountSections } from '@/ui/utils/filterAccountSections';
import { AccountsPanel } from '@juvare/contact-management/ui/features/accounts';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import React from 'react';
import { useSearchParams } from 'react-router';
import { RmsAccountProfileHeader } from './RmsAccountProfileHeader';

export const RmsAccountPanel = () => {
    const [searchParams] = useSearchParams();
    const userState = useUserState();

    const id = searchParams.get('id');
    const { backgroundCheckData } = useSelectedPersonBackgroundCheckData(id ?? undefined);

    const { getAccountAdditionalMenuItems } = useAccountSlideoutAdditionalMenuItems(backgroundCheckData);
    const formatters = useAccountAuditFormatter();

    return (
        <AccountsPanel
            customAccountProfileHeaderComponent={RmsAccountProfileHeader}
            customAccountSlideoutMenuItems={getAccountAdditionalMenuItems}
            customAccountSlideoutDetailsComponent={RmsAccountDetails}
            accountEntityAuditFormatters={formatters}
            onAccountAuditEntitiesList={(defaultEntitiesList) => [
                ...(defaultEntitiesList ?? []),
                {
                    entity: backgroundCheckEntityName,
                    entityIds: [],
                },
            ]}
            onFilterAccountSections={(sections) => filterAccountSections(userState, sections)}
        />
    );
};
